"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { AppMenu } from "@/shared";
import { match } from "path-to-regexp";
import { useState } from "react";

type SubNavItemProps = {
  menu: {
    paths?: string[];
    title: string;
  };
};

function SubNavItem({ menu }: SubNavItemProps) {
  const currentPath = usePathname() || "";
  const isActive =
    menu?.paths &&
    menu.paths.some((path: any) => {
      const urlMatch = match(path);
      return urlMatch(currentPath);
    });
  const hrefPath = menu?.paths && menu.paths[0] ? menu.paths[0] : "#";

  return (
    // 서브 메뉴 항목에 원하는 스타일을 직접 적용합니다.
    <Link
      href={hrefPath}
      className={`
          block 
          px-5 
          py-3
          hover:text-[#31777A]
          hover:bg-light-10
          transition-colors duration-150

          ${isActive ? "text-[#31777A]" : "text-black-almostBlack"}
        `}
    >
      <div
        className="medium-text-16 "
        style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
      >
        {menu.title}
      </div>
    </Link>
  );
}

type NavItemProps = {
  menu: {
    paths?: string[];
    title?: string;
    children?: Array<{
      path: string;
      title: string;
    }>;
  };
};

function NavItem({ menu }: NavItemProps) {
  const currentPath = usePathname() || "";
  const isActive =
    menu.paths &&
    menu.paths.some((path: any) => {
      const urlMatch = match(path);
      return urlMatch(currentPath);
    });
  const [open, setOpen] = useState(false);
  const title = menu.title && (
    <div className="medium-text-20">{menu.title}</div>
  );

  return (
    <div
      className={`
      w-auto
      flex-1
      relative 
      group 
      ${menu.children && "has-sub "}
      transition-colors duration-200
    `}
    >
      <Link
        href={menu.paths && menu.paths[0] ? menu.paths[0] : "#"}
        className={`
                  menu-link 
                  flex items-center gap-2  pl-4 py-6
                  hover:text-[#31777A]
                  transition-colors duration-200 

                  ${isActive ? "text-[#31777A]" : "text-black-almostBlack"}
                `}
      >
        {title}
      </Link>
      {menu.children && (
        <div
          className="
            menu-submenu 
            absolute 
            top-full 
            left-0 
            bg-white 
            border border-light-20 
            shadow-sm
            min-w-[180px] 
            py-3
            z-50
            mt-2
            rounded-3xl

            opacity-0 
            max-h-0 
            invisible 
            overflow-hidden 
            transform -translate-y-2

            transition-all duration-300 ease-out

            group-hover:opacity-100 
            group-hover:max-h-[500px] 
            group-hover:visible
            group-hover:translate-y-0

          "
        >
          {menu.children.map((submenu, i) => (
            <SubNavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

export function TopMenuNav() {
  return (
    <div className="flex-1 overflow-visible hidden min-[991px]:flex">
      {AppMenu.filter((item) => item.is_active).map((item, i) => (
        <NavItem key={i} menu={item as any} />
      ))}
    </div>
  );
}
